export default __webpack_public_path__ + "static/media/40295.42220bd6.jpg";